var map = require('./map');
/*
* 获取Url查询参数 公共方法
*/
function getParams(name, href) {
    var href = href || window.location.href,
        value = '';

    if (name) {
        var reg = new RegExp(name + '=([^&]*)', 'g');
        href.replace(reg, function ($0, $1) {
            value = decodeURI($1);
        });
    } else {
        value = {};
        var reg = /\b(\w+)=([^\/&]*)/g;
        href.replace(reg, function ($0, $1, $2) {
            value[$1] = decodeURI($2);
        });
    }
    return value;
}

const getDateList = (num) => {
    var today = new Date();
    today = today.getFullYear() + "/" + (today.getMonth() + 1) + "/" + today.getDate();
    let arr = []
    for (let i = 0; i < num; i++) {
        var date = new Date(today);
        date.setDate(new Date().getDate() + i)
        let tempdate = date.getFullYear() + '-' + (date.getMonth() + 1) + "-" + date.getDate();
        let week = '';
        switch (date.getDay()) {
            case 1: week = "星期一"; break;
            case 2: week = "星期二"; break;
            case 3: week = "星期三"; break;
            case 4: week = "星期四"; break;
            case 5: week = "星期五"; break;
            case 6: week = "星期六"; break;
            case 0: week = "星期日"; break;
        }
        let dayName = i == 0 ? '今天' : i == 1 ? '明天' : i == 2 ? "后天" : week;
        arr.push({
            time: tempdate,
            week: week,
            dayName: dayName,
            weekNum: date.getDay() == 0 ? 7 : date.getDay()
        })
    }
    // console.log(arr);
    return arr;
}


// 是否为正确手机格式
const IsPhone = (str) => {
    var reg = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/;
    return reg.test(str)

}
// 是否为正确身份证号
const IsCard = (str) => {
    // var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    var reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
    return reg.test(str);
}

const toHanzi = (v) => {
    if (!v) return '';
    v = v.split('\\u');
    var str = '';
    for (var i = 0, len = v.length; i < len; i++) {
        if (v[i]) {
            str += String.fromCharCode(parseInt(v[i], 16).toString(10));
        }
    }
    return str;
}
//函数防抖
const debounce=(fn,interval=1000)=>{
    var timer;
    var gapTime  = interval || 1000;
    return function(){
      clearTimeout(timer);
      var context = this;
      var args = arguments;
      timer = setTimeout(() => {
        fn.call(context,args)
      }, gapTime);
    }
  }
// 节流函数
function throttle(func, delay=100) {
    let lastCall = 0;
    return function(...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) return;
        lastCall = now;
        return func.apply(this, args);
    };
}
module.exports={
    map,getParams,
    getDateList,
    IsPhone,
    IsCard,
    toHanzi,
    debounce,
    throttle
}